import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';

import { MainConfig } from '../../core';
import { AdministratorService } from '../shared';

@Component({
  selector: 'administrator-list',
  templateUrl: './administrator-list.component.html',
  styleUrls: ['./administrator-list.component.scss'],
  host: { 'class': 'atn-list-crud' }

})
export class AdministratorListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public administratorService: AdministratorService
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Administradores - ' + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/administrator-list/administrator-list.component.ts